import { render } from "./ActionBar.vue?vue&type=template&id=5d324b32&scoped=true&ts=true"
import script from "./ActionBar.vue?vue&type=script&lang=ts"
export * from "./ActionBar.vue?vue&type=script&lang=ts"

import "./ActionBar.vue?vue&type=style&index=0&id=5d324b32&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d324b32"]])

export default __exports__